export function stopPropagation(e?: React.SyntheticEvent) {
  e?.stopPropagation();
}

export function stop(e?: React.SyntheticEvent) {
  e?.stopPropagation();
  e?.preventDefault();
}
